<template>
  <div class="instruments has-background-white-bis fixspace">

    <section class="hero is-medium has-background-white-ter is-bold is-hidden-mobile">
      <div class="hero-body">
        <div class="container has-text-centered">
          <h1 class="title is-uppercase" style="font-weight: 900;">
            {{ $t('general.instruments') }}
          </h1>
          <h2 class="subtitle py-5 has-text-grey-light">
            INSTRUMENTS
          </h2>
        </div>
      </div>
    </section>

    <section class="section pt-5 has-background-white-ter is-bold is-hidden-tablet">
      <div class="container">
        <h1 class="title is-4 is-uppercase pb-5" style="font-weight: 900;">
          {{ $t('general.instruments') }}
        </h1>
      </div>
    </section>

    <section>
      <div class="container is-max-desktop" style="margin-top: -50px;">
        <div class="box">
          <div class="tabs instruments is-centered">
            <div class="columns is-mobile is-vcentered is-gapless has-text-weight-semibold"
              style="height:62px; margin-right: auto; margin-left: auto;">
              <router-link :to="{name: 'InstrumentsAll'}"
                v-slot="{ href, navigate, isActive, isExactActive }" custom>
                <div class="column mx-2"
                  @click="navigate"
                  role="link"
                  :class="[
                          isActive && 'router-link-active',
                          isExactActive && 'router-link-exact-active'
                          ]"
                  >
                  <a :href="href" @click="navigate" :aria-label="$t('instruments.all')">
                    {{ $t('instruments.all') }}
                  </a>
                </div>
              </router-link>
              <router-link :to="{name: 'InstrumentsKeyboard'}"
               v-slot="{ href, navigate, isActive, isExactActive }" custom>
               <div class="column mx-2"
                  @click="navigate"
                  role="link"
                  :class="[
                          isActive && 'router-link-active',
                          isExactActive && 'router-link-exact-active'
                          ]"
                  >
                  <a :href="href" @click="navigate" :aria-label="$t('instruments.keyboard')">
                    <!-- eslint-disable -->
                    <svg width="40px" height="40px" viewBox="-3 -3 30 25" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                      <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <g transform="translate(-293.000000, -161.000000)" fill="#000000" fill-rule="nonzero">
                          <g transform="translate(293.000000, 161.000000)">
                            <path d="M0,0 L0,20 L24,20 L24,0 L0,0 Z M2,2 L22,2 L22,10 L2,10 L2,2 Z M2,12 L4,12 L4,16 L6,16 L6,12 L7,12 L7,16 L9,16 L9,12 L12,12 L12,16 L14,16 L14,12 L15,12 L15,16 L17,16 L17,12 L18,12 L18,16 L20,16 L20,12 L22,12 L22,18 L2,18 L2,12 Z"></path>
                          </g>
                        </g>
                      </g>
                    </svg>
                    <!-- eslint-enable -->
                  </a>
                  <a :href="href" @click="navigate" :aria-label="$t('instruments.keyboard')">
                    {{ $t('instruments.keyboard') }}
                  </a>
                </div>
              </router-link>
              <router-link :to="{name: 'InstrumentsString'}"
                v-slot="{ href, navigate, isActive, isExactActive }" custom>
                <div class="column mx-2"
                  @click="navigate"
                  role="link"
                  :class="[
                          isActive && 'router-link-active',
                          isExactActive && 'router-link-exact-active'
                          ]"
                  >
                  <a :href="href" @click="navigate" :aria-label="$t('instruments.string')">
                    <!-- eslint-disable -->
                    <svg width="40px" height="40px" viewBox="-3 -3 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                      <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <g transform="translate(-335.000000, -158.000000)" fill="#000000" fill-rule="nonzero">
                          <g transform="translate(335.000000, 158.000000)">
                            <path d="M24.90625,0.0625 C24.90625,0.0625 23.222656,0.710938 22.84375,1.09375 C22.527344,1.410156 22.402344,1.835938 22.4375,2.25 L21.59375,1.4375 L20.53125,2.5 L21.40625,3.40625 L20.6875,4.09375 L19.8125,3.21875 L18.75,4.28125 L19.5625,5.09375 L17.75,6.78125 L17.46875,6.5 C16.472656,5.503906 15.15625,5 13.84375,5 C12.53125,5 11.246094,5.503906 10.25,6.5 L8.75,7.96875 L8.21875,8.5 L8.59375,9.15625 C8.992188,9.902344 8.96875,10.625 8.15625,11.4375 C7.640625,11.953125 7.15625,12.109375 6.6875,12.09375 C6.21875,12.078125 5.71875,11.875 5.28125,11.4375 L4.59375,10.71875 L1.8125,13.5 C-0.578125,15.890625 -0.578125,19.796875 1.8125,22.1875 L3.8125,24.1875 C6.203125,26.578125 10.109375,26.578125 12.5,24.1875 L15.28125,21.40625 L14.5625,20.71875 C14.125,20.28125 13.921875,19.78125 13.90625,19.3125 C13.890625,18.84375 14.046875,18.359375 14.5625,17.84375 C15.375,17.03125 16.097656,17.007813 16.84375,17.40625 L17.5,17.78125 L18.03125,17.25 L19.5,15.75 C21.488281,13.761719 21.488281,10.519531 19.5,8.53125 L19.21875,8.25 L20.90625,6.4375 L21.6875,7.21875 L22.75,6.15625 L21.90625,5.3125 L22.59375,4.59375 L23.4375,5.4375 L24.5,4.375 L23.6875,3.5625 C24.121094,3.617188 24.574219,3.488281 24.90625,3.15625 C25.285156,2.777344 25.9375,1.09375 25.9375,1.09375 L24.90625,0.0625 Z M13.84375,7 C14.636719,7 15.449219,7.292969 16.0625,7.90625 L16.28125,8.125 L11.375,12.625 L13.34375,14.625 L17.875,9.71875 L18.09375,9.9375 C19.316406,11.160156 19.316406,13.121094 18.09375,14.34375 L16.9375,15.5 C15.664063,15.167969 14.253906,15.339844 13.15625,16.4375 C12.308594,17.285156 11.875,18.339844 11.90625,19.375 C11.925781,20.074219 12.191406,20.722656 12.5625,21.3125 L11.0625,22.78125 C9.4375,24.40625 6.84375,24.40625 5.21875,22.78125 L5.15625,22.71875 L8.84375,18.3125 L7.6875,17.15625 L3.28125,20.84375 L3.21875,20.78125 C1.59375,19.15625 1.59375,16.5625 3.21875,14.9375 L3.28125,14.875 L4.6875,13.4375 C5.277344,13.808594 5.925781,14.074219 6.625,14.09375 C7.660156,14.125 8.714844,13.691406 9.5625,12.84375 C10.660156,11.746094 10.832031,10.335938 10.5,9.0625 L11.65625,7.90625 C12.269531,7.292969 13.050781,7 13.84375,7 Z"></path>
                          </g>
                        </g>
                      </g>
                    </svg>
                    <!-- eslint-enable -->
                  </a>
                  <a :href="href" @click="navigate" :aria-label="$t('instruments.string')">
                    {{ $t('instruments.string') }}
                  </a>
                </div>
              </router-link>
              <router-link :to="{name: 'InstrumentsWind'}"
                v-slot="{ href, navigate, isActive, isExactActive }" custom>
                <div class="column mx-2"
                  @click="navigate"
                  role="link"
                  :class="[
                          isActive && 'router-link-active',
                          isExactActive && 'router-link-exact-active'
                          ]"
                  >
                  <a :href="href" @click="navigate" :aria-label="$t('instruments.wind')">
                    <!-- eslint-disable -->
                    <svg width="40px" height="40px" viewBox="-2 -1 32 18" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                        <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                            <g id="Artboard" transform="translate(-377.000000, -163.000000)" fill="#000000" fill-rule="nonzero">
                                <g id="icons8-trumpet" transform="translate(377.000000, 163.000000)">
                                    <path d="M25.5,0 L25.21875,0.375 L21.65625,5 L17,5 L17,3 L15,3 L15,5 L14,5 L14,3 L12,3 L12,5 L11,5 L11,3 L9,3 L9,5.09375 C6.726563,5.5625 5,7.59375 5,10 C5,12.40625 6.726563,14.4375 9,14.90625 L9,16 L11,16 L11,15 L12,15 L12,16 L14,16 L14,15 L15,15 L15,16 L17,16 L17,14.96875 C18.679688,14.71875 20,13.246094 20,11.5 C20,10.953125 19.851563,10.460938 19.625,10 L21.65625,10 L25.21875,14.625 L25.5,15 L28,15 L28,0 L25.5,0 Z M26,2.65625 L26,12.34375 L22.9375,8.375 L22.65625,8 L10,8 C8.898438,8 8,8.898438 8,10 L16.5,10 C17.339844,10 18,10.660156 18,11.5 C18,12.164063 17.589844,12.707031 17,12.90625 L17,11 L15,11 L15,13 L14,13 L14,11 L12,11 L12,13 L11,13 L11,11 L9,11 L9,12.84375 C7.828125,12.4375 7,11.320313 7,10 C7,8.332031 8.332031,7 10,7 L22.65625,7 L22.9375,6.625 L26,2.65625 Z M0,6 L0,10 L2,10 L2,9 L4.09375,9 C4.214844,8.28125 4.460938,7.609375 4.8125,7 L2,7 L2,6 L0,6 Z"></path>
                                </g>
                            </g>
                        </g>
                    </svg>
                    <!-- eslint-enable -->
                  </a>
                  <a :href="href" @click="navigate" :aria-label="$t('instruments.wind')">
                    {{ $t('instruments.wind') }}
                  </a>
                </div>
              </router-link>
              <router-link :to="{name: 'InstrumentsPercussion'}"
                v-slot="{ href, navigate, isActive, isExactActive }" custom>
                <div class="column mx-2"
                  @click="navigate"
                  role="link"
                  :class="[
                          isActive && 'router-link-active',
                          isExactActive && 'router-link-exact-active'
                          ]"
                  >
                  <a :href="href" @click="navigate" :aria-label="$t('instruments.percussion')">
                    <!-- eslint-disable -->
                    <svg width="40px" height="40px" viewBox="-3 -3 34 30" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                      <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <g transform="translate(-420.000000, -159.000000)" fill="#000000" fill-rule="nonzero">
                          <g transform="translate(420.000000, 159.000000)">
                            <path d="M0.53125,0 L0,1.9375 L3,2.78125 L3,6 L0,6 L0,12 L3,12 L3,24 L5,24 L5,12 L7.09375,12 C6.40625,13.179688 6,14.542969 6,16 C6,17.945313 6.714844,19.734375 7.875,21.125 L6.96875,24.03125 L9.0625,24.03125 L9.5,22.59375 C10.785156,23.472656 12.332031,24 14,24 C15.652344,24 17.191406,23.488281 18.46875,22.625 L18.90625,24.03125 L21,24.03125 L20.09375,21.15625 C21.269531,19.761719 22,17.960938 22,16 C22,14.542969 21.59375,13.179688 20.90625,12 L23,12 L23,24 L25,24 L25,12 L28,12 L28,6 L20,6 L20,10.71875 C18.53125,9.050781 16.390625,8 14,8 C11.609375,8 9.46875,9.050781 8,10.71875 L8,6 L5,6 L5,3.3125 L7.46875,4 L8,2.09375 L0.53125,0 Z M23,0 L23,2 L25,2 L25,0 L23,0 Z M20,3 L20,5 L28,5 L28,3 L20,3 Z M2,8 L6,8 L6,10 L2,10 L2,8 Z M22,8 L26,8 L26,10 L22,10 L22,8 Z M14,10 C17.324219,10 20,12.675781 20,16 C20,19.324219 17.324219,22 14,22 C10.675781,22 8,19.324219 8,16 C8,12.675781 10.675781,10 14,10 Z M17,17 C16.449219,17 16,17.449219 16,18 C16,18.550781 16.449219,19 17,19 C17.550781,19 18,18.550781 18,18 C18,17.449219 17.550781,17 17,17 Z"></path>
                          </g>
                        </g>
                      </g>
                    </svg>
                    <!-- eslint-enable -->
                  </a>
                  <a :href="href" @click="navigate" :aria-label="$t('instruments.percussion')">
                    {{ $t('instruments.percussion') }}
                  </a>
                </div>
              </router-link>
            </div>
          </div>
        </div>
        <router-view></router-view>
      </div>
    </section>

  </div>
</template>

<script>
export default {
  name: 'Instruments',

  metaInfo() {
    return {
      title: this.$t('title.instruments'),
      meta: [
        { name: 'description', vmid: 'description', content: this.$t('about.abouthero1') },
        { property: 'og:title', vmid: 'og:title', content: this.$t('title.instruments') },
        { property: 'og:image', vmid: 'og:image', content: 'https://musian.app/assets/open_graph_logo.jpg' },
        { property: 'og:description', vmid: 'og:description', content: this.$t('about.abouthero1') },
      ],
    };
  },

  mounted() {
    this.forGtag();
  },

  beforeDestroy() {
    clearTimeout(this.timer);
  },

  methods: {
    forGtag() {
      this.timers = setTimeout(() => {
        this.$emit('forGtagStatus', this.$t('title.instruments'));
      }, 500);
    },
  },
};
</script>

<style lang="scss">
.instruments .router-link-exact-active {
  border-bottom: none;
}
.tabs.instruments .router-link-exact-active a {
  color: #000;
}
.tabs.instruments a {
  color: #595959;
  padding:0px 16px;
  border-bottom: none;
}
.tabs.instruments li {
  padding:0px 8px;
}
</style>
